import Component from '@ux/component';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Link from '@ux/link';
import { TrayMenu } from '@ux/tray-menu';
import { url } from '@ux/header-util';
import { golf } from './enums';
import User from '@ux/icon/user';

class LoginLogout extends Component {
  render() {
    const props = this.props;
    let loginUrl = '';
    let logoutUrl = '';
    if (props.urls && props.urls.sso) {
      loginUrl =
        props.urls.sso.login &&
        url.updateQuery(props.urls.sso.login.href, props.sso);
      logoutUrl =
        props.urls.sso.logout &&
        url.updateQuery(props.urls.sso.logout.href, props.sso);
    }

    const userIcon = props.loggedIn && props.isPro ? 'is-pro' : '';

    const trayName = <div className='title-text'>{ props.displayName }</div>;

    const trayMenu = (
      <TrayMenu
        className={ this.classNames(
          'login-logout-tray',
          'hidden-sm-down',
          userIcon
        ) }
        name={ trayName }
        fullwidth={ false }
        showClose={ false }
        data-eid='uxp.hyd.help_header.account_tray.click'>
        <div className='container'>
          <div className='row'>
            <Link
              { ...props }
              urlArgs={ props.urlArgs }
              href={ logoutUrl }
              className='login-logout-out-link'>
              <FormattedMessage id={ golf.logout } />
            </Link>
          </div>
        </div>
      </TrayMenu>
    );

    const loginLink = (
      <div
        className={ this.classNames(
          'login-logout-link-container',
          'hidden-sm-down',
          userIcon
        ) }>
        <Link
          { ...props }
          urlArgs={ props.urlArgs }
          href={ loginUrl }
          className='login-logout-link'>
          <User className='user-icon' width={ 16 } height={ 16 } />
          <FormattedMessage id={ golf.login } />
        </Link>
      </div>
    );

    return props.loggedIn ? trayMenu : loginLink;
  }
}

LoginLogout.defaultProps = {
  isPro: false,
  loggedIn: false
};

LoginLogout.propTypes = {
  displayName: PropTypes.string,
  isPro: PropTypes.bool,
  loggedIn: PropTypes.bool,
  urlArgs: PropTypes.object,
  urls: PropTypes.object.isRequired,
  sso: PropTypes.object
};

export default LoginLogout;
